module.exports = __webpack_public_path__ + "static/media/welcome-clothes.20b487fe.png";